<template>
  <div id="app">
    <NavbarComponent/>
    <main>
      <router-view v-if="displayAll" />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import NavbarComponent from '@/components/NavbarComponent';
import FooterComponent from '@/components/FooterComponent';
export default {
  components: {
    NavbarComponent,
    FooterComponent,
  },
  data() {
    return {
      displayAll: false,
    };
  },
  methods: {},
  async created() {
    await this.$store.dispatch('auth');
    const token = JSON.parse(localStorage.getItem('accessToken'));
    const aliveToken = +(new Date().getTime() / 1000 - token.issuedAt).toFixed() < token.expiresIn;
    const forCL = token.expiresIn - +(new Date().getTime() / 1000 - token.issuedAt).toFixed();
    console.log(`истекает через - ${Math.floor(forCL / 60)} мин ${forCL % 60} сек`);
    if (token && aliveToken) {
      this.displayAll = true;
      this.$store.dispatch('setToken', token.accessToken);
    } else {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      await this.$store.dispatch('auth');
    }
  },
};
</script>

<style lang="scss">
@import 'assets/styles/main.scss';
</style>
